module["exports"] = [
  ""
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/state.js
// module id = 1032
// module chunks = 0